export default __webpack_public_path__ + "static/FAQ_iMCE (MV)-b169d89ed1108bf08e92726c9fa1f62e.pdf";